import request from '../utils/request';

export function getBankAccounts(params) {
    return request.get('/bankAccounts', {params});
}

export function getBankAccount(bankAccountId) {
    return request.get(`/bankAccounts/${bankAccountId}`);
}

export function createBankAccount(data) {
    return request.post(`/bankAccounts`, data);
}

export function updateBankAccount(bankAccountId, data) {
    return request.put(`/bankAccounts/${bankAccountId}`, data);
}

export function deleteBankAccount(bankAccountId) {
    return request.delete(`/bankAccounts/${bankAccountId}`);
}

export function cloneBankAccount(bankAccountId) {
    return request.get(`/bankAccounts-clone/${bankAccountId}`);
}
